import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { Card, CardContent, Grid, Paper } from "@material-ui/core";
import { renderDateTextField2 } from "../../form-global-components/components-form-components-for-react-final-form";
class FormFieldsTabDates extends Component {
  render() {
    // console.log('dates props = ', this.props );
    // console.log('dates props = ', this.props.referraloutcome );
    // console.log('dates props = ', this.props._reduxForm.initialValues.referraloutcome );
    // console.log('dates props = ', this.props._reduxForm.values.referraloutcome );
    return (
      <div>
        <Paper>
          <Card>
            <CardContent>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderDateTextField2}
                    id="referralreceiveddate"
                    name="referralreceiveddate"
                    label="Referral Received Date"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderDateTextField2}
                    id="referralprojectedreleasedate"
                    name="referralprojectedreleasedate"
                    label="Referral Projected Release Date"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderDateTextField2}
                    id="referralrequestedadmissiondate"
                    name="referralrequestedadmissiondate"
                    label="Referral Requested Admission Date"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Field
                    locked={this.props.locked}
                    component={renderDateTextField2}
                    id="referralapproveddate"
                    name="referralapproveddate"
                    label="Referral Approved Date"
                  />
                </Grid>
              </Grid>

              <br />
              <hr />
              <br />
{/* 
              {
              // removed per Crosspoints request as they want all dates visible during the referral process to put the dates in early

              // this.props.referraloutcome === '4'
              this.props._reduxForm.values.referraloutcome === "4" ||
              // this.props.referraloutcome === '5'
              this.props._reduxForm.values.referraloutcome === "5" ||
              // this.props.referraloutcome === '6'
              this.props._reduxForm.values.referraloutcome === "6" 
              ? (
*/}

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="referraldeniedadmissiondate"
                      name="referraldeniedadmissiondate"
                      label="Referral Denied Admission Date"
                    />
                  </Grid>
                </Grid>
{/*                 
              ) : null}
*/}

{/* 
              {
              // removed per Crosspoints request as they want all dates visible during the referral process to put the dates in early
              
              // this.props.referraloutcome === '3'
              this.props._reduxForm.values.referraloutcome === "3" 
              ? (
*/}
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="referralapprovedadmissiondate"
                      name="referralapprovedadmissiondate"
                      label="Referral Approved Admission Date (Client Approved Admission Date)"
                    />
                  </Grid>
                </Grid>
{/*
              ) : null}
*/}

              <br />
              <hr />
              <br />

{/* 
{ value: '1', label: 'Accepted and Pending Arrival' },
{ value: '2', label: 'On Hold' },

{ value: '3', label: 'Accepted Client' },

{ value: '4', label: 'Cancelled / Withdrawn' },
{ value: '5', label: 'No Show for Admission' },
{ value: '6', label: 'Denied' }
*/}

              {/* {this.props._reduxForm.values.referraloutcome === '3' ? ( */}
              {this.props.referraloutcome === "3" ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="clientrrchdeligibilitydate"
                      name="clientrrchdeligibilitydate"
                      label="Client (RRC) HD Eligibility Date"
                    />
                  </Grid>
                </Grid>
              ) : null}

              {/* {this.props._reduxForm.values.referraloutcome === '3' ? ( */}
              {this.props.referraloutcome === "3" ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="referralprojectedreleasedate"
                      name="referralprojectedreleasedate"
                      label="Client Projected Release Date"
                    />
                  </Grid>
                </Grid>
              ) : null}

              {/* {this.props._reduxForm.values.referraloutcome === '3' ? ( */}
              {this.props.referraloutcome === "3" ? (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderDateTextField2}
                      id="clientdischargedate"
                      name="clientdischargedate"
                      label="Client Discharge Date"
                    />
                  </Grid>
                </Grid>
              ) : null}

              <br />
              <hr />
              <br />

{/* 
{value: '1', label: "PENDING"},
{value: '2', label: "SUCCESSFUL"},
{value: '3', label: "UnSUCCESSFUL"},
{value: '4', label: "NEUTRAL"} 
*/}

{/* 
{value: '1', label: "REFUSED TO ANSWER"},
{value: '2', label: "Not Provided"},
{value: '3', label: "Dependant and stable"},
{value: '4', label: "Independant and stable"},
{value: '5', label: "Supportive Housing (eg Sober Living)"},
{value: '6', label: "Homeless or Unstable"},
{value: '7', label: "Shelter"},
{value: '8', label: "Institution"},
{value: '9', label: "Hospital"},
{value: '10', label: "NO FURTHER CONTACT"}     
*/}

              {/* {this.props._reduxForm.values.clientdischargestatus === '2' ? ( */}
              {this.props.clientdischargestatus === "2" ? (
                <>
                  {/* {this.props.postdischargeattemptedcontact90desults === '10' ? ( */}
                  {/* {this.props._reduxForm.values.postdischargeattemptedcontact90desults === '10' ? ( */}
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Field
                        locked={this.props.locked}
                        component={renderDateTextField2}
                        id="postdischargecontactdate90d"
                        name="postdischargecontactdate90d"
                        label="Post Discharge Attempted Contact Date 90 days"
                      />
                    </Grid>
                  </Grid>
                  {/* ) : null} */}

                  {/* {this.props.postdischargeattemptedcontact180dresults === '10' ? ( */}
                  {/* {this.props._reduxForm.values.postdischargeattemptedcontact180dresults === '10' ? ( */}
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Field
                        locked={this.props.locked}
                        component={renderDateTextField2}
                        id="postdischargecontactdate180d"
                        name="postdischargecontactdate180d"
                        label="Post Discharge Attempted Contact Date 180 days"
                      />
                    </Grid>
                  </Grid>
                  {/* ) : null} */}

                  {/* {this.props.postdischargeattemptedcontact12mresults === '10' ? ( */}
                  {/* {this.props._reduxForm.values.postdischargeattemptedcontact12mresults === '10' ? ( */}
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Field
                        locked={this.props.locked}
                        component={renderDateTextField2}
                        id="postdischargecontactdate12m"
                        name="postdischargecontactdate12m"
                        label="Post Discharge Attempted Contact Date 12 Months"
                      />
                    </Grid>
                  </Grid>
                  {/* ) : null} */}

                  {/* {this.props.postdischargeattemptedcontact24mresults === '10' ? ( */}
                  {/* {this.props._reduxForm.values.postdischargeattemptedcontact24mresults === '10' ? ( */}
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Field
                        locked={this.props.locked}
                        component={renderDateTextField2}
                        id="postdischargecontactdate24m"
                        name="postdischargecontactdate24m"
                        label="Post Discharge Attempted Contact Date 24 Months"
                      />
                    </Grid>
                  </Grid>
                  {/* ) : null} */}

                  {/* {this.props.postdischargeattemptedcontact36mresults === '10' ? ( */}
                  {/* {this.props._reduxForm.values.postdischargeattemptedcontact36mresults === '10' ? ( */}
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <Field
                        locked={this.props.locked}
                        component={renderDateTextField2}
                        id="postdischargecontactdate36m"
                        name="postdischargecontactdate36m"
                        label="Post Discharge Attempted Contact Date 36 Months"
                      />
                    </Grid>
                  </Grid>
                  {/* ) : null} */}
                </>
              ) : null}
            </CardContent>
          </Card>
        </Paper>
      </div>
    );
  }
}
FormFieldsTabDates.propTypes = {
  locked: PropTypes.bool,
  showReferralOutcome: PropTypes.number,
};
export default FormFieldsTabDates;
